import { render, staticRenderFns } from "./page-member.vue?vue&type=template&id=19663b25&scoped=true"
import script from "./page-member.vue?vue&type=script&lang=js"
export * from "./page-member.vue?vue&type=script&lang=js"
import style0 from "./page-member.vue?vue&type=style&index=0&id=19663b25&prod&scoped=true&lang=scss"
import style1 from "./page-member.vue?vue&type=style&index=1&id=19663b25&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19663b25",
  null
  
)

export default component.exports